import { Icon, IconNames, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react';

import styles from './topbarButton.module.scss';

type TopbarButtonProps = {
  icon: IconNames;
  label: string;
  tooltip?: ReactNode;
  notification?: string | number;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const TopbarButton = forwardRef<HTMLButtonElement, TopbarButtonProps>(
  function TopbarButton(
    { className, icon, label, tooltip, notification, ...buttonProps },
    ref,
  ) {
    const rootClass = classnames(styles.root, className);

    return (
      <Tooltip content={tooltip || label}>
        <button
          ref={ref}
          type="button"
          aria-label={label}
          className={rootClass}
          {...buttonProps}
        >
          <Icon name={icon} size={20} />

          {notification && (
            <span className={styles.notification}>{notification}</span>
          )}
        </button>
      </Tooltip>
    );
  },
);
